import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton"; // You can use react-loading-skeleton package for the loader

function PortfolioDetails() {
  const { id ,lang} = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const [portfolioDetails, setPortfolioDetails] = useState(null); // Start with null instead of empty array

  const getPortfolio = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/portfolio/getbyid/${id}`);
      setPortfolioDetails(res.data);
    } catch (error) {
      console.error("Error:", error);
    }
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getPortfolio();
  }, [getPortfolio]);

  // If portfolioDetails is still null, show loading skeleton
  if (!portfolioDetails) {
    return (
      <div className="background_port_details">
        <div className="container cont_port_deatils">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-7 col-md-12 col-sm-12">
              <Skeleton height={40} width="80%" /> {/* Skeleton for title */}
              <Skeleton height={20} width="90%" />{" "}
              {/* Skeleton for description */}
              <Skeleton height={40} width="30%" /> {/* Skeleton for button */}
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12">
              <Skeleton height={250} width="100%" /> {/* Skeleton for image */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {portfolioDetails.map((portfolio) => (
        <div key={portfolio.portfolio_id}>
          <div className="background_port_details">
            <div className="container cont_port_deatils">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-7 col-md-12 col-sm-12">
                  <h1 className="title_portf_details">{portfolio.title}</h1>
                  <p className="content_portf_details">
                    {portfolio.description}
                  </p>
                  <div className="cont_btn_visit">
                    <a
                      href={portfolio.link}
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="cont_btn_visit"
                    >
                      <button
                        type="button"
                        className={`btn btn-light hover_filter_btn_portfolio visit_website_portfolio`}
                      >
                       {lang === 'ar' ? ' زيارة الموقع' : ' Visit Website'}
                      </button>
                    </a>
                  </div>
                </div>

                <div className="col-lg-5 col-md-12 col-sm-12">
                  <img
                    src={`${API_URL}/${portfolio.image}`}
                    alt="portfolio details img"
                    title="portfolio img"
                    className="img_portf_deatils"
                  />
                </div>
              </div>
            </div>
          </div>
          <section className="mt-5">
            <div className="container">
              <h1 className="title_service_provided_portfolio">
                {lang === 'ar' ? 'الخدمات المقدمة ' : 'Services Provided '}
              </h1>
              <div className="row d-flex justify-content-center align-items-center">
                {portfolio.services_provided.map((service) => (
                  <div
                    className="col-lg-3 col-md-6 col-sm-12 "
                    key={service.service_id}
                  >
                    <Link
                      target="__blank"
                      to={`${service.service_link}`}
                      className="cont_service_provided_portfolio"
                    >
                      <img
                        src={`${API_URL}/${service.service_icon}`}
                        alt="graphicdesign"
                        title="graphicdesign"
                        className="icon_portf_details"
                      />
                      <h4>{service.service_title}</h4>
                      <p className="content_service_provided">
                        {service.service_description}
                      </p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      ))}
    </>
  );
}

export default PortfolioDetails;
